import { render, staticRenderFns } from "./ConvalescentMonitor.vue?vue&type=template&id=2ae8ce1c&scoped=true&"
import script from "./ConvalescentMonitor.vue?vue&type=script&lang=js&"
export * from "./ConvalescentMonitor.vue?vue&type=script&lang=js&"
import style0 from "./ConvalescentMonitor.vue?vue&type=style&index=0&id=2ae8ce1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae8ce1c",
  null
  
)

export default component.exports